import { isAllowedDomain } from './isAllowedDomain';

export const isProductionEnvironment = () => {
    const hostname = window.location.hostname;

    return !isAllowedDomain(hostname);
};
